import $ from 'jquery';
import 'select2';

const lang = document.documentElement.lang;
const tr = {
  'pt-BR': {
    city: 'Selecione a cidade',
    unity: 'Selecione a unidade',
    business: 'Selecione seu negócio',
  },
  en: {
    city: 'Select the city',
    unity: 'Select the unity',
    business: 'Select your business',
  },
  es: {
    city: 'Selecciona la ciudad',
    unity: 'Seleccione la unidad',
    business: 'Selecciona tu negocio',
  },
};

const dfCity = new Option(tr[lang].city, '');
const dfUnity = new Option(tr[lang].unity, '');
const dfBusiness = new Option(tr[lang].business, '');

export const stateCity = () => {
  $('.js-state-filter')
    .select2({
      theme: 'classic',
    })
    .on('change', function (e) {
      var post = {};

      if (e.target.value === '') {
        $('#js-cities').empty().append(dfCity);
        return;
      }

      post.id = e.target.value;
      post._token = $('meta[name="csrf-token"]').attr('content');

      var url = '/estados/busca-cidades/' + post.id;

      $.ajax({
        type: 'GET',
        url: url,
        data: post,
        cache: false,
        dataType: 'json',
      }).then(function (data) {
        $('#js-cities').empty().append(dfCity);

        $.each(data, function (index, element) {
          var option = new Option(element, index);
          $('#js-cities').append(option);
        });
      });
    });

  $('#js-cities').select2({
    theme: 'classic',
  });
};

export const area = () => {
  $('.js-areas')
    .select2({
      placeholder: 'Selecione sua área',
      theme: 'classic',
    })
    .on('select2:select', function (e) {
      if (e.params.data.text === 'Outro') {
        $('#area_other').show();
      } else {
        $('#area_other').hide();
        $('[name="area_other"]').val('');
      }
    });
};

export const regional = () => {
  $('.js-regional')
    .select2({
      theme: 'classic',
    })
    .on('change', function (e) {
      if (e.target.value === '') {
        $('#unity_id').empty().append(dfUnity);
        $('#business_id').empty();
        return;
      }

      $.ajax({
        type: 'GET',
        url: `/busca-unidades/${e.target.value}`,
        data: { _token: $('meta[name="csrf-token"]').attr('content') },
        cache: false,
        dataType: 'json',
      }).then(function (data) {
        $('#unity_id').empty().append(dfUnity);
        $('#business_id').empty();

        $.each(data, function (index, element) {
          var option = new Option(element, index);
          $('#unity_id').append(option);
        });
      });
    });
};

export const directory = () => {
  $('.js-directories').select2({
    placeholder: 'Selecione',
    theme: 'classic',
  });
};

export const unity = () => {
  $('.js-unity')
    .select2({
      theme: 'classic',
    })
    .on('change', function (e) {
      if (e.target.value === '') {
        $('#business_id').empty().append(dfBusiness);
        return;
      }

      $.ajax({
        type: 'GET',
        url: `/busca-negocios/${e.target.value}`,
        data: { _token: $('meta[name="csrf-token"]').attr('content') },
        cache: false,
        dataType: 'json',
      }).then(function (data) {
        $('#business_id').empty().append(dfBusiness);

        $.each(data, function (index, element) {
          var option = new Option(element, index);
          $('#business_id').append(option);
        });
      });
    });
};

export const business = () => {
  $('.js-business').select2({
    theme: 'classic',
  });
};

export const funcional = () => {
  $('.js-funcional').select2({
    placeholder: 'Selecione sua categoria funcional',
    theme: 'classic',
  });
};

export const habilities = () => {
  $('.js-habilities')
    .select2({
      placeholder: 'Selecione sua habilidade',
      theme: 'classic',
      multiple: true,
    })
    .on('select2:select', function (e) {
      if (e.params.data.text === 'Outra habilidade não listada') {
        $('#other').removeClass('u-display--none');
      }
    })
    .on('select2:unselect', function (e) {
      if (e.params.data.text === 'Outra habilidade não listada') {
        $('#other').addClass('u-display--none');
        $('#other_hability').val('');
      }
    });
};
